import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownInsuranceServices', request)
}

async function post(request) {
    return await postMethod('/api/ownInsuranceServices', request)
}

async function put(request) {
    return await putMethod('/api/ownInsuranceServices', request)
}

export {get, post, put}
